/** Keep in sync with backend/src/services/forms/formDefinitions.js sanitizeFileName. */
export function sanitizeFormFileName(name: string): string {
  return String(name).toLowerCase().replace(/[^a-z0-9-_]+/g, '-').replace(/(^-|-$)/g, '') || 'form'
}

export function formNamesMatch(a: string | null | undefined, b: string | null | undefined): boolean {
  const left = String(a || '').trim()
  const right = String(b || '').trim()
  if (!left || !right) return false
  if (left === right) return true
  if (left.toLowerCase() === right.toLowerCase()) return true
  return sanitizeFormFileName(left) === sanitizeFormFileName(right)
}
